import React from "react";
import {Form, Button, Alert} from "react-bootstrap";
import EmailValidator from "email-validator";

class RegisterForm extends React.Component{
    state = {
        data: {
            "name": "",
            email: "",
            password: ""
        },

        errors:{},
        isSubmit: "no",
        loading: false
    };
    onchange = event => this.setState({
        data: {...this.state.data, [event.target.name] : event.target.value }
    });
    onsubmit = (e) => {
        e.preventDefault();
        this.setState({loading: true});
        var errors = this.validate(this.state.data);
        this.setState( {errors} );
        if (Object.keys(errors).length === 0) {
            this.props.submit(this.state.data).catch(err => {
                this.setState({errors: err.response.data.errors, loading: false});
            }).then(msg => {
                this.setState({loading: false});
            });
            this.setState({ isSubmit: "yes"});
        }

    };

    validate = (data) => {
        const errors = {};
        if (EmailValidator.validate(data.email) === false) {errors.email = "Invalid email"};
        return errors; 
    };

    showAndHidePassword = () => {
        const password = document.querySelector("#password");
        if(password.type==="password"){
            password.type="text";
        }else{
            password.type="password"; 
        }
    }

    render(){
        const {name, email, password} = this.state.data;
        const {errors} = this.state;
        const {showAndHidePassword} = this;
        return(
            <div>
                { errors.global && <Alert variant = "danger" className="errmsg"
                >
                        {errors.global}
                    </Alert>
                }
                <Form className="ak3_form" onSubmit = {this.onsubmit}>
                    <h1 className="text-center">Register Form </h1>
                    <h5 className="danger">{errors.email}</h5>
                    <Form.Group controlId="Name">
                        <Form.Label className="form-lab"
                        >Name</Form.Label>
                        <Form.Control 
                            type="text" 
                            required 
                            placeholder="Write Your Name"
                            name = "name"
                            value = {name}
                            onChange = {this.onchange}
                            className="bg-clickable" 
                            autoComplete="off"
                        />
                    </Form.Group>
                    <Form.Group controlId="email">
                        <Form.Label className="form-lab"
                        >Email address</Form.Label>
                        <Form.Control 
                            type="email" 
                            required 
                            placeholder="example@example.com"
                            name = "email"
                            value = {email}
                            onChange = {this.onchange}
                            className="bg-clickable" 
                            autoComplete="off"
                        />
                    </Form.Group>
                    <Form.Group controlId="password">
                        <Form.Label className="form-lab">Password</Form.Label>
                        <Form.Control 
                            type="password" 
                            required 
                            placeholder="Make it secure" 
                            name = "password"
                            value = {password}
                            onChange = {this.onchange}
                            autoComplete="off"
                            className="bg-clickable"
                        />
                    <div className="showHidePasswordContainer">
                        <input type="checkbox" id="showPassword" onClick={showAndHidePassword}/>
                        <label for="showPassword" type="button" className="showHidePassword">Show Password</label>
                    </div>
                    </Form.Group>


                    <Button variant="success" className="ml-ak3" type = "submit">Submit</Button>
                </Form>
                {this.state.loading && (
                <div className="loader">
                    <div></div>
                    <h1>Please Wait...</h1>
                </div>
                )}
            </div>
        );
    };
};

export default RegisterForm;